var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCancelButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02891 4.02891 0 9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9ZM6.15234 7.31602L7.8082 8.96836L6.15234 10.6523C5.82539 10.9828 5.82539 11.5172 6.15234 11.816C6.48281 12.1746 7.01719 12.1746 7.31602 11.816L8.96836 10.1918L10.6523 11.816C10.9828 12.1746 11.5172 12.1746 11.816 11.816C12.1746 11.5172 12.1746 10.9828 11.816 10.6523L10.1918 8.96836L11.816 7.31602C12.1746 7.01719 12.1746 6.48281 11.816 6.15234C11.5172 5.82539 10.9828 5.82539 10.6523 6.15234L8.96836 7.8082L7.31602 6.15234C7.01719 5.82539 6.48281 5.82539 6.15234 6.15234C5.82539 6.48281 5.82539 7.01719 6.15234 7.31602Z",
    fill: "#A8071A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCancelButton);
export default __webpack_public_path__ + "static/media/RedCancelButton.b3482e59ebdbb7bca20c33084a85ef6b.svg";
export { ForwardRef as ReactComponent };